import { Routes } from '@angular/router'

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: async () => await import('./home/home.routes').then((m) => m.HOME_ROUTES)
  },
  {
    path: 'user-manager',
    loadChildren: async () =>
      await import('./user-manager/user-manager.routes').then(
        (m) => m.USER_MANAGER_ROUTES
      )
  },
  {
    path: 'feedbacks',
    loadChildren: async () =>
      await import('./feedbacks/feedbacks.routes').then((m) => m.FEEDBACKS_ROUTES)
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
]
